import Translation from 'components/Translation'
import { classNames } from 'utils/dom-helpers'
import { SaveCardSuccessProps } from './types'

function SaveCardSuccess({
    new_card,
    card_type,
    back_button_label,
    handleOnModalClosed,
}: SaveCardSuccessProps) {
    return (
        <div
            className={classNames(
                'bg-white rounded-2xl shadow-2xl p-8 m-auto w-2/5'
            )}
        >
            <div className="flex justify-center p-4">
                <i
                    className="feather-check bg-green-600 text-lg rounded-full"
                    style={{
                        color: 'white',
                        background: 'green',
                        padding: '1px 6px',
                    }}
                ></i>
            </div>
            <div className="text-center circular inline-block self-center text-3xl text-primary-dark mx-auto mb-5">
                <div>
                    <Translation content_key='added_card' />
                </div>
            </div>
            <div className="flex justify-center mb-4">
                <span className="bg-green-200/50 px-3 py-1 font-bold rounded-full items-center flex m-auto justify-center text-xs uppercase">
                    {card_type} **** {new_card?.cardNumber.slice(-4)}
                </span>
            </div>
            <button
                className={classNames(
                    'group relative w-full flex justify-center',
                    'py-4 mt-10 px-3 border border-transparent',
                    'text-md rounded-md text-white',
                    'focus:outline-none',
                    'bg-primary hover:bg-primary-dark focus:ring-2 focus:ring-offset-2 focus:ring-primary-light'
                )}
                onClick={handleOnModalClosed}
            >
                
                <Translation content_key={back_button_label || 'back_to_payments'} />
            </button>
        </div>
    )
}

export default SaveCardSuccess
